"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('four-round-point-connection', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M16 10C16 13.3137 13.3137 16 10 16C8.59649 16 7.30553 15.5181 6.28356 14.7107C4.89265 13.6119 4 11.9102 4 10C4 6.68629 6.68629 4 10 4C11.9102 4 13.6119 4.89265 14.7107 6.28356C15.5181 7.30553 16 8.59649 16 10Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M16 38C16 39.4035 15.5181 40.6945 14.7107 41.7164C13.6119 43.1073 11.9102 44 10 44C6.68629 44 4 41.3137 4 38C4 36.0898 4.89265 34.3881 6.28356 33.2893C7.30553 32.4819 8.59649 32 10 32C13.3137 32 16 34.6863 16 38Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 10C44 11.9102 43.1073 13.6119 41.7164 14.7107C40.6945 15.5181 39.4035 16 38 16C34.6863 16 32 13.3137 32 10C32 8.59649 32.4819 7.30553 33.2893 6.28356C34.3881 4.89265 36.0898 4 38 4C41.3137 4 44 6.68629 44 10Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 38C44 41.3137 41.3137 44 38 44C36.0898 44 34.3881 43.1073 33.2893 41.7164C32.4819 40.6945 32 39.4035 32 38C32 34.6863 34.6863 32 38 32C39.4035 32 40.6945 32.4819 41.7164 33.2893C43.1073 34.3881 44 36.0898 44 38Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M6.28356 14.7107C7.30553 15.5181 8.59649 16 10 16C13.3137 16 16 13.3137 16 10C16 8.59649 15.5181 7.30553 14.7107 6.28356M6.28356 14.7107C4.89265 13.6119 4 11.9102 4 10C4 6.68629 6.68629 4 10 4C11.9102 4 13.6119 4.89265 14.7107 6.28356M6.28356 14.7107C5.42098 16.3525 4.7799 18.1288 4.40007 20M14.7107 6.28356C16.3525 5.42098 18.1288 4.7799 20 4.40007M33.2893 6.28356C32.4819 7.30553 32 8.59649 32 10C32 13.3137 34.6863 16 38 16C39.4035 16 40.6945 15.5181 41.7164 14.7107M33.2893 6.28356C34.3881 4.89265 36.0898 4 38 4C41.3137 4 44 6.68629 44 10C44 11.9102 43.1073 13.6119 41.7164 14.7107M33.2893 6.28356C31.6475 5.42098 29.8712 4.7799 28 4.40007M41.7164 14.7107C42.579 16.3525 43.2201 18.1288 43.5999 20M41.7164 33.2893C40.6945 32.4819 39.4035 32 38 32C34.6863 32 32 34.6863 32 38C32 39.4035 32.4819 40.6945 33.2893 41.7164M41.7164 33.2893C43.1073 34.3881 44 36.0898 44 38C44 41.3137 41.3137 44 38 44C36.0898 44 34.3881 43.1073 33.2893 41.7164M41.7164 33.2893C42.579 31.6475 43.2201 29.8712 43.5999 28M33.2893 41.7164C31.6475 42.579 29.8712 43.2201 28 43.5999M14.7107 41.7164C15.5181 40.6945 16 39.4035 16 38C16 34.6863 13.3137 32 10 32C8.59649 32 7.30553 32.4819 6.28356 33.2893M14.7107 41.7164C13.6119 43.1073 11.9102 44 10 44C6.68629 44 4 41.3137 4 38C4 36.0898 4.89265 34.3881 6.28356 33.2893M14.7107 41.7164C16.3525 42.579 18.1288 43.2201 20 43.5999M6.28356 33.2893C5.42098 31.6475 4.7799 29.8712 4.40007 28",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M18 24H30M24 30V18",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;